import { useState } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Bento } from "@/components/Bento";
import { MenuBrowser } from "@/components/MenuBrowser";
import { HowItWorks, Contact, Footer } from "@/components/Sections";
import { OrderDrawer } from "@/components/OrderDrawer";
import { SmoothScroll } from "@/components/SmoothScroll";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [active, setActive] = useState("cake-pops");
  const pick = (id) => {
    setActive(id);
    scrollToId("menu");
  };
  return (
    <div data-testid="home-page">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Bento onPick={pick} />
        <MenuBrowser active={active} setActive={setActive} />
        <HowItWorks />
        <Contact />
      </main>
      <Footer />
      <OrderDrawer />
    </div>
  );
}
